<template>
    <div>
        <a-input-search class="serach_input" placeholder="搜索地点" v-model="keyword"></a-input-search>
        <baidu-map
            :center="center"
            :scroll-wheel-zoom="true"
            :zoom="zoom">
            <bm-view class="map"></bm-view>

            <!-- 圆形覆盖物：半径由父组件传入的 radius prop 控制 -->
            <bm-circle
                :center="circleCenter"
                :radius="radius"
                stroke-color="#007aff"
                :stroke-weight="2"
                :stroke-opacity="0.6"
                fill-color="#007aff"
                :fill-opacity="0.2">
            </bm-circle>

            <!-- 标记点 -->
            <bm-marker :position="circleCenter"></bm-marker>

            <bm-local-search
                :keyword="keyword"
                @infohtmlset="get_markersset"
                :pageCapacity="2"
                :auto-viewport="true"
                :location="location">
            </bm-local-search>
        </baidu-map>
    </div>
</template>

<script>
import Search from 'vue-baidu-map/components/search/LocalSearch';
export default {
    components: {
        Search
    },
    name: "simple-map",
    props: {
        // 接收父组件传来的半径（单位：米）
        radius: {
            type: Number,
            default: 300
        }
    },
    data: () => ({
        center: { lng: 115.86631, lat: 28.695285 },
        circleCenter: { lng: 115.86631, lat: 28.695285 }, // 圆心，跟随搜索/定位变化
        zoom: 13,
        keyword: '',
        location: '南昌',
    }),
    methods: {
        get_markersset(e) {
            // 搜索到地点后，把圆心移动到该位置
            if (e && e.point) {
                this.circleCenter = { lng: e.point.lng, lat: e.point.lat };
                this.center = { lng: e.point.lng, lat: e.point.lat };
            }
            this.$emit('get_title', e);
        },
    }
};
</script>

<style scoped>
.map {
    width: 100%;
    height: 250px;
}
.serach_input {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 99;
    max-width: 200px;
}
</style>